import { call, takeLatest, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { apiGetCall, apiPostCall, apiPutCall } from '../api';
import { showAPIerror } from '../../pages/SellerProfile/APIs/Helpers';
import {
    getUserProfileStart,
    getUserProfileFailure,
    getUserProfileSuccess,
    requestAccessFailure,
    requestAccessStart,
    requestAccessSuccess,
    requestSuccess,
    UpdateUserProfileFailure,
    UpdateUserProfileStart,
    UpdateUserProfileSuccess,
    resetSubmitSuccess
} from '../slices/mySettingSlice';
import { setApiStatus,setShowSuccessPopUp, fecthAllUsers } from '../slices/sellerProfileSlice';

const URL = process.env.REACT_APP_API_BASE;

function* checkTokenExpired() {
    // if (jwtDecode(token).exp < Date.now() / 1000) {
    yield (window.instance as any)
        .acquireTokenSilent({
            redirectUri: process.env.REACT_APP_AZURE_REDIRECT,
            authority: process.env.REACT_APP_AZURE_AUTHORITY
        })
        .then((res) => {
            axios.defaults.headers.common['Authorization'] = `Bearer ${res.idToken}`;
        })
        .catch((e) => {
            if (e instanceof InteractionRequiredAuthError) {
                (window.instance as any).loginRedirect();
            }
        });
}


function* SpAPIgetUserProfileSaga(action) {
    try {
        yield call(checkTokenExpired);
        const { user_id } = yield select((state) => state.sellerProfile);
        const response = yield call(apiGetCall, URL + 'user-details/' + user_id);
        if (response) {
            yield put(getUserProfileSuccess(response));
        }
    } catch (error: any) {
        const {spPageText} = yield select(({ sellerProfile: { spPageText } }) => ({ spPageText }));
        yield put(getUserProfileFailure(showAPIerror(error, spPageText,setShowSuccessPopUp,setApiStatus, 'SpAPIgetUserProfileSaga')))
    }

}


function* requestAccessSaga(action) {
    try {
        yield call(checkTokenExpired);
        const { access } = action.payload;
        const { user_id } = yield select((state) => state.sellerProfile);
        const response = yield call(apiPostCall, URL + 'user-additional-access/' + user_id, access);
        if (response.status === 'successful') {
            yield put(requestAccessSuccess(response));
            yield put(requestSuccess(true));
        }
    } catch (error: any) {
        const {spPageText} = yield select(({ sellerProfile: { spPageText } }) => ({ spPageText }));
        yield put(requestAccessFailure(showAPIerror(error, spPageText,setShowSuccessPopUp,setApiStatus, "SpAPIRequestAccess")))
    }
}


function* SpAPIUpdateUserProfileSaga(action) {
    try {
        yield call(checkTokenExpired);
        const { formUpdates } = action.payload;
        const {seller_id, user_id, isAdmin } = yield select((state) => state.sellerProfile);
        const returnFields = [
            "user_first_name",
            "user_last_name",
            "user_phone",
            "notifications",
            "preferences",
            "preferred_language_type",
        ];

        const formattedUpdates = {};
        const getValByObjKey = (field, obj) => {
            Object.keys(obj).forEach((key) => {
                if (typeof obj[key] === "object" && obj[key] !== null && key !== field) {
                    getValByObjKey(field, obj[key]);
                } else if (key === field) {
                    formattedUpdates[key] = obj[key].content;
                }
            });
        };
        returnFields.forEach((retKey) => {
            getValByObjKey(retKey, formUpdates["editMySettings"]);
        });
        formattedUpdates["user_opted_preferences"] = formattedUpdates["preferences"];
        formattedUpdates["user_opted_notifications"] = isAdmin
            ? []
            : formattedUpdates["notifications"]; //Admins can't have their notifications changed; API expects empty array for them

        delete formattedUpdates["notifications"];
        delete formattedUpdates["preferences"];

        const response = yield call(apiPutCall, URL + 'user-details/' + user_id, formattedUpdates);
        if (response.message === 'Successful') {
            yield put(UpdateUserProfileSuccess(response));
            yield put(getUserProfileStart());
            yield put(fecthAllUsers({seller_id, user_id}));
            yield put(resetSubmitSuccess(true));
        }
    } catch (error: any) {
        const {spPageText} = yield select(({ sellerProfile: { spPageText } }) => ({ spPageText }));
        yield put(UpdateUserProfileFailure(showAPIerror(error, spPageText,setShowSuccessPopUp,setApiStatus, "SpAPIUpdateUserProfile")))
    }
}


export default function* mySettingSaga() {
    yield takeLatest(getUserProfileStart, SpAPIgetUserProfileSaga);
    yield takeLatest(requestAccessStart, requestAccessSaga);
    yield takeLatest(UpdateUserProfileStart, SpAPIUpdateUserProfileSaga);
}

